import apiService from '../apiService';

const EXPORT_URL = 'setup/export'
const dynamicExportService = {

    async dynamicExport(type, filterData = null) {
        console.log('filterData', filterData)
        try {
            const response = await apiService.post(`/${EXPORT_URL}/${type}`, filterData, {
                responseType: 'blob'
            });
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async exportTableReports(payload) {
        try {
            const response = await apiService.post(`/exporter`, payload, {
                responseType: 'blob'
            });
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

};

export default dynamicExportService;